// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__Bm-Z5","resendInfoText":"OnGoingPaymentBox_resendInfoText__3K4V0"};